import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ChromelessService {
  private readonly _chromeless$ = new BehaviorSubject<boolean>(false);
  public readonly chromeless$ = this._chromeless$.asObservable();

  constructor(private router: Router, private rootRoute: ActivatedRoute) {
    // Initial computation
    this._recompute();
    // Listen for completed navigations
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => this._recompute());
  }

  private _recompute(): void {
    let snapshot = this.rootRoute.snapshot;
    while (snapshot.firstChild) {
      snapshot = snapshot.firstChild;
    }
    const value = snapshot.data?.chromeless === true;
    if (value !== this._chromeless$.value) {
      this._chromeless$.next(value);
    }
  }

  /** Current chromeless value */
  public get value(): boolean { return this._chromeless$.value; }
}